import { createAction, props } from '@ngrx/store';
import { BillingItemV26, BillingitemAddRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';

export const selectServices = createAction(
  '[V26 Wizard Service Step] Select Add ServiceToContract Service Step',
  props<{ servicesStep: BillingItemV26[] }>(),
);

export const selectContracts = createAction(
  '[V26 Wizard Contract Step] Select Add ServiceToContract Contract Step',
  props<{ contractsStep: ContractTreeNodeV26[] }>(),
);

export const exitAddServicesToContractsWizard = createAction('[V26 AddServicesToContracts Wizard Page] Exit Add ServiceToContract Wizard');

export const destroyWizard = createAction('[V26 AddServicesToContracts Wizard Page] Destroy Wizard');

export const createNewAddServicesToContracts = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceToContract Information Step',
  props<{ request: BillingitemAddRequestV26 }>(),
);

export const createNewAddServicesToContractsSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceToContract Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewAddServicesToContractsFail = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceToContract Information Step Fail',
  props<{ errorMessage: string }>(),
);
